import * as React from "react"
import { connect } from "react-redux"

import Breadcrumb from "./Breadcrumb"
import { GlobalState } from "../../../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"
import Siblings from "./Siblings"
import {
    getSortedSiblingsByEditable,
    SortedSiblingsByEditable,
} from "../selectors"
import { ISmartLocation } from "../index"

interface OwnProps {
    loadMoreLabel: string
    noResultsLabel: string
    smartLocationFilterLabel: string
}

type StateProps = ISmartLocation & SortedSiblingsByEditable

type Props = OwnProps & StateProps & DispatchProps

export const SmartLocation = ({
    breadcrumbs,
    siblingsShown,
    siblings,
    editableSiblings,
    notEditableSiblings,
    loadMoreLabel,
    noResultsLabel,
    smartLocationFilterLabel,
    filterSiblings,
    loadMoreSiblings,
    reorderSiblings,
    removeSibling,
}: Props): JSX.Element => {
    if (!breadcrumbs) {
        return <></>
    }

    const siblingsElement = (
        <>
            {!!siblings && siblingsShown && (
                <Siblings
                    loadMoreLabel={loadMoreLabel}
                    noResultsLabel={noResultsLabel}
                    filterSiblings={filterSiblings}
                    loadMoreSiblings={loadMoreSiblings}
                    reorderSiblings={reorderSiblings}
                    removeSibling={removeSibling}
                    siblingsContent={siblings.siblingsContent}
                    editableSiblings={editableSiblings}
                    notEditableSiblings={notEditableSiblings}
                    filter={siblings.filter}
                    hasMore={siblings.hasMore}
                    isLoading={siblings.isLoading}
                    isLoadingMore={siblings.isLoadingMore}
                    smartLocationFilterLabel={smartLocationFilterLabel}
                />
            )}
        </>
    )

    // if there is a workspace breadcrumb then the siblings popups will be shown after the second (workspace) breadcrumb
    // otherwise after the welcome page breadcrumb (first breadcrumb)
    const showPopupAfterWelcomePage = breadcrumbs.length === 1

    return (
        <>
            {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={index}>
                    <Breadcrumb
                        breadcrumb={breadcrumb}
                        data-ft-breadcrumb-index={index}
                    />

                    {showPopupAfterWelcomePage &&
                        index === 0 &&
                        siblingsElement}

                    {!showPopupAfterWelcomePage &&
                        index === 1 &&
                        siblingsElement}
                </React.Fragment>
            ))}
        </>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.smartLocation,
    ...getSortedSiblingsByEditable(state.smartLocation),
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartLocation)
